/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Paste_Tour_UrlInputs */

const en_paste_tour_url = /** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paste your Matterport or other 3D walkthrough URL here`)
};

const id_paste_tour_url = /** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tempel URL Matterport atau panduan 3D lainnya di sini`)
};

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const es_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const fr_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const de_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const ja_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const zh_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const ar_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const it_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const ru_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const pt_paste_tour_url = en_paste_tour_url;

/** @type {(inputs: Paste_Tour_UrlInputs) => LocalizedString} */
const ko_paste_tour_url = en_paste_tour_url;

/**
* | output |
* | --- |
* | "Paste your Matterport or other 3D walkthrough URL here" |
*
* @param {Paste_Tour_UrlInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const paste_tour_url = /** @type {((inputs?: Paste_Tour_UrlInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Paste_Tour_UrlInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_paste_tour_url(inputs)
	if (locale === "es") return es_paste_tour_url(inputs)
	if (locale === "fr") return fr_paste_tour_url(inputs)
	if (locale === "de") return de_paste_tour_url(inputs)
	if (locale === "ja") return ja_paste_tour_url(inputs)
	if (locale === "zh") return zh_paste_tour_url(inputs)
	if (locale === "ar") return ar_paste_tour_url(inputs)
	if (locale === "id") return id_paste_tour_url(inputs)
	if (locale === "it") return it_paste_tour_url(inputs)
	if (locale === "ru") return ru_paste_tour_url(inputs)
	if (locale === "pt") return pt_paste_tour_url(inputs)
	return ko_paste_tour_url(inputs)
});